export const validations:{[key:string]:string} ={
  "type":"The type field is mandatory. Select type from the dropdown.",
  "effective_form_date":"Effective from date is mandatory.",
  "state":"Select state from the dropdown.",
  "district":"Select districts from the dropdown.",
  "sub_district":"Please select sub_district",
  "health_block_name":`Health Block name is mandatory.`,
  "zone_name":"Zone name is mandatory.",
  "circle_name":"Circle name is mandatory.",
  "division_name":"Division name is mandatory.",
  "zone_exists":"The name already exists. Choose a unique name to continue.",
  "type_name":"The type field is mandatory. Select type from the dropdown.",
  "sub_division_name":"Sub Division name is mandatory.",
  "wards":"Select Wards from the dropdown.",
  "gram_panchayat":"Select Gram Panchayat / ADC Village from the dropdown.",
  "villages":"Select Villages from the dropdown.",
}